import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { nl } from 'date-fns/locale/nl'

import { PageInfoProvider } from '../../theme/context/PageInfoProvider'
import { ThemeProvider } from '../../theme/context/ThemeProvider'

export default function Providers({ children }) {
  return (
    <ThemeProvider>
      {/* The LocalizationProvider provides a context for the MUI DatePicker
      components. To prevent re-mounting this component for every DatePicker
      that is rendered, we just keep it top level here. */}
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={nl}>
        <PageInfoProvider>{children}</PageInfoProvider>
      </LocalizationProvider>
    </ThemeProvider>
  )
}
